<template>
  <v-content class="bg-content">
    <div id="buttons" title="The Sky was All Purple There were People running Everywhere">  
      <button @click="toggleVisibility('showContainer')">Toggle OpenAi</button>
      <button @click="toggleVisibility('showConsoleLog')">Toggle Console</button> 
      <button id="fullscreenButton" @click="toggleFullscreen">Fullscreen</button>
      <a href="https://github.com/ldijkman/Ace_Seventh_Heaven/discussions/6" target="_blank" title="Hellup"><button>?</button></a>        
    </div>
    <br><br>
    <iframe width="360" height="240" src="https://www.youtube.com/embed/VaPQZR8EarI" title="OpenAi API Stream Floating Code Assistant" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

    <br>
    <div class="cont_ai_ner" v-show="showContainer">
      <div class="Heaven" id="Heaven" title="You Can Drag Me & Resize on Corners and Borders">
        <button class="dropbtn" @click="toggleDropdown">Menu</button>
        <div class="dropdown-content" v-show="dropdownOpen">
          <button class="dropbt" style="border:none;">-</button><br>
             <a href="https://platform.openai.com/signup" target="_blank">
             <button class="dropbt" style="border:none;color:green" onmouseover="this.focus()" onmouseout="this.blur()">Get Started OpenAI Signup</button></a>
            <button class="dropbt" style="border:none;">-</button><br>
            <a href="https://platform.openai.com/account/api-keys" target="_blank"><button class="dropbt" style="border:none;color:green" onmouseover="this.focus()" onmouseout="this.blur()">Get an API_KEY</button></a>
            <button class="dropbt" style="border:none;">-</button><br>
             
           <button onclick="openNewWindow()" value="Chat-GPT WebPage" title="Chat-GPT WebPage" class="dropbt" style="border:none;color:green;" onmouseover="this.focus()" onmouseout="this.blur()">Chat-GPT WebPage</button>
           
            <a href="https://platform.openai.com/docs/models" target="_blank" title=""><button class="dropbt" style="border:none;" onmouseover="this.focus()" onmouseout="this.blur()">AI models info</button></a>
            <a href="https://platform.openai.com/usage" target="_blank" title="Traffic Tokens Usage"><button class="dropbt" style="border:none;" onmouseover="this.focus()" onmouseout="this.blur()">AI Usage Info</button></a>
            <button class="dropbt" style="border:none;">-</button><br>
            <a href="https://status.openai.com/" target="_blank"><button class="dropbt" style="border:none;color:orange" onmouseover="this.focus()" onmouseout="this.blur()">OpenAI API Server Status</button></a>
            <button class="dropbt" style="border:none;">-</button><br>
            <a href="https://github.com/ldijkman/Ace_Seventh_Heaven/discussions/6" target="_blank" title=""><button class="dropbt" style="border:none;" onmouseover="this.focus()" onmouseout="this.blur()">Comments, Suggestions, Feedback</button></a>
            <button class="dropbt" style="border:none;">-</button><br>
            <a href="https://ldijkman.github.io/Ace_Seventh_Heaven/The_AfterWorld.html" target="_blank"><button class="dropbt" style="border:none;color:purple;" onmouseover="this.focus()" onmouseout="this.blur()">The AfterWorld</button></a>
            <button class="dropbt" style="border:none;">-</button><br>
             <button class="dropbt" onclick="MaximizeAI();" style="border:none;">FullScreen</button><br>
              <button class="dropbt" style="border:none;">-</button><br>
        </div>
      </div>
      <button @click="toggleVisibility('showContainer')" style="float:right;margin:3px;margin-right:5px;" title="Close Window">X</button>
      <div class="AfterWorld" id="AfterWorld" title="The AfterWorld">
        <div id="spinner" v-if="isLoading" class="spinner" title="Loading..."></div>
        <div style="border: 1px solid white; margin: 10px; padding: 10px;" title="Enter an Openai API_KEY">
          <label class="label"><a href="https://platform.openai.com/account/api-keys" target="_blank">API_KEY</a>:</label>
          <input type="text" v-model="API_KEY" placeholder="Type or Paste API_KEY here..." @mouseover="expandInput" @mouseout="shrinkInput">
          <br>
          <!-- Model Selection Here -->
          <select v-model="selectedModel">
            <option value="gpt-3.5-turbo-1106" title="For me the Fastest and 16k" style="color:green;">gpt-3.5-turbo-1106  16k</option>
                    <option value="gpt-3.5-turbo" title="Slow for Me? Bussy? and 4k" style="color:green;">gpt-3.5-turbo 4k</option>
                    <option value="gpt-3.5-turbo-16k" title="Dont know 16k">gpt-3.5-turbo-16k</option>
                    <option value="code-davinci-002" title="Dont know" style="color:red;">code-davinci-002</option>
                    <option value="gpt-4-1106-preview" title="Dont know" style="color:red;">gpt-4-1106-preview</option>
                    <option value="gpt-4" title="Dont know" style="color:red;">gpt-4</option>
          </select>
          <button @click="clearChat" title="WARNING!!!: Clear Chat Area/History">Clear Chat</button>
        </div>
        <div id="resultContainer" style="border: 1px solid gray; margin: 10px; padding: 10px;">
          <p id="resultText" v-html="resultText" title="Chat Content"></p>
        </div>
        <center>
          <!-- <input type="text" v-model="promptInput" placeholder="Question Me..." @keyup.enter="generateResponse"/> -->
          <input type="text" v-model="promptInput" :style="inputStyle" placeholder="Question Me..." @keyup.enter="generateResponse" @focus="expandInput" @blur="shrinkInput"/>

          <div><button @click="generateResponse" title="Submit Question">Generate</button>
          <button @click="stopGeneration" :disabled="!isLoading" title="Stop">Stop</button></div>
        </center>
      </div>
    </div>
    <div class="Hell" v-show="showConsoleLog">
      <pre id="console-log" title="Console Log"></pre>
    </div>
  </v-content>
</template>


<script>
export default {
  name: 'Assistant',
  data() {
    return {
      showContainer: true,
      API_KEY: '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',
      promptInput: '',
      resultText: '',
      selectedModel: 'gpt-3.5-turbo-1106',
      isLoading: false,
      showConsoleLog: false,
      dropdownOpen: false,
      controller: null, // For managing abortable fetch request
      inputWidth: '200px', // Used for dynamically adjusting the input field width
    };
  },
  methods: {
    toggleVisibility(which) {
      this[which] = !this[which];
      var myDiv = document.getElementById(which);
      if (myDiv.style.display === "none") {
                myDiv.style.display = "block";
                 console.warn('run in console => toggleVisibility("'+which+'");');
            } else {
                myDiv.style.display = "none";
                console.warn('run in console => toggleVisibility("'+which+'");');
            }
    },
    toggleFullscreen() {
const elem = document.documentElement;

    if (!document.fullscreenElement) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
    }
    },
    async generateResponse() {
      if (!this.promptInput.trim()) {
        this.resultText += "<br><font><b>ERROR:</b> Please enter a question.</font><br>";
        // Corrected logic to set a default prompt
        return; // Stop execution if input is empty
      }
      this.isLoading = true;
      this.controller = new AbortController();
      try {
        const response = await fetch("https://api.openai.com/v1/completions", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.API_KEY}`,
          },
          
          body: JSON.stringify({
            prompt: this.promptInput,
          }),
          signal: this.controller.signal,
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        this.resultText += `<br>${data.choices[0].text}<br>`;
      } catch (error) {
        this.resultText += `<br><font style="color:red;">Error fetching response: ${error.message}</font><br>`;
      } finally {
        this.isLoading = false;
      }
    },
    stopGeneration() {
      if (this.controller) {
        this.controller.abort();
        this.isLoading = false;
      }
    },

    // Adapted from Code 10, modified to fit Vue.js component structure
    scrollAfterWorldToBottom() {
      // In Vue, prefer using refs instead of document.getElementById
      this.$refs.afterWorld.scrollTop = this.$refs.afterWorld.scrollHeight;
    },

    scrollToTop() {
      // Adapted for Vue.js
      this.$refs.afterWorld.scrollTo({ top: 0, behavior: "smooth" });
    },

    scrollToBottom() {
      // Adapted for Vue.js
      this.$refs.afterWorld.scrollTo({ top: this.$refs.afterWorld.scrollHeight, behavior: "smooth" });
    },
    expandInput() {
      // Expands the input field width
      this.inputWidth = '400px'; // Example expanded width
    },

    shrinkInput() {
      // Shrinks the input field width back to its original size
      this.inputWidth = '200px'; // Example original width
    },

    openNewWindow(url) {
      // Opens a new window with the specified URL
      window.open(url, "_blank", "width=600, height=400");
    },

    clearChat() {
      // Clears the chat content
      this.resultText = '';
    },

    toggleDropdown() {
      // Toggles the visibility of the dropdown menu
      this.dropdownOpen = !this.dropdownOpen;
    },

    // Remaining methods (expandInput, shrinkInput, etc.) are correctly placed
  },
  computed: {
    // Dynamically adjust styles based on component state
    inputStyle() {
      // Returns an object with CSS properties for binding to the input element
      return {
        width: this.inputWidth,
      };
    },
  },

  mounted() {
    // Example: Load API key from localStorage or perform other initialization tasks
    const storedApiKey = localStorage.getItem("API_KEY");
    if (storedApiKey) {
      this.API_KEY = storedApiKey;
    }
  }
}
</script>
<style scoped>
    body{
      
      background:lightgray;
      margin:50px;

      
    }
.cont_ai_ner {
  position: fixed;
        display:float;
        min-height:90px;
        min-width:350px;
        background-color: #f1f1f1;
        border: 1px solid gray;
        left: 40px;
        top:  140px;
        width: 500px;
        height: 500px;
        border-radius: 5px;
}

.Heaven {
  position:absolute;
        height: 25px;
        width:99%;
        border-bottom: 1px solid #eee;
        background-color: lightblue;
        -webkit-border-top-left-radius: 5px;
        -webkit-border-top-right-radius: 5px;
        -moz-border-radius-topleft: 5px;
        -moz-border-radius-topright: 5px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        margin:2px;
        cursor:move;
        border: 1px solid gray;
}

.AfterWorld {
  flex-grow: 1;
  overflow-y: auto;
  padding: 10px;
}

.Hell {
  background-color: #eee;
  padding: 10px;
  text-align: center;
}

#buttons {
  position: fixed;
  top: 10px; /* Adjusted for consistency */
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  background-color: purple; /* Consolidated from conflicting styles */
  padding: 8px; /* Consolidated from conflicting styles */
}
.buttons {
  position: fixed;
  top: 10px; /* Adjusted for consistency */
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  background-color: purple; /* Consolidated from conflicting styles */
  padding: 8px; /* Consolidated from conflicting styles */
}
button {
  cursor: pointer;
}

.spinner {
  border: 4px solid #f3f3f3; /* Light gray border */
  border-top: 4px solid orange; /* Orange color for spinning */
  border-radius: 50%; /* Circular shape */
  width: 22px;
  height: 22px;
  animation: spin 2s linear infinite; /* Spin animation */
  display: none; /* Initially hidden */
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.dropbtn {
  position: relative;
}

.dropdown {
  position: absolute;
  display: block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  width: 200px;
  min-height: 260px; /* Corrected typo */
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  margin: -3px; /* To avoid gap */
}

.dropdown-content a {
  color: black;
  padding: 12px 16px; /* Corrected typo */
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {background-color: #ddd;}

.dropdown:hover .dropdown-content {display: block;}

.dropdown:hover .dropbtn {background-color: #3e8e41;}
</style>
